const enumValue = (description, label) => Object.freeze({
    toString: () => description,
    label
});

export const FRONT = enumValue('FRONT', 'Frente');
export const FRONT_LEFT = enumValue('FRONT_LEFT', 'Frente Esquerda');
export const FRONT_RIGHT = enumValue('FRONT_RIGHT', 'Frente Direita');

export const REAR = enumValue('REAR', 'Traseira');
export const REAR_LEFT = enumValue('REAR_LEFT', 'Traseira Esquerda');
export const REAR_RIGHT = enumValue('REAR_RIGHT', 'Traseira Direita')

export const values = () => [
    FRONT,
    FRONT_LEFT,
    FRONT_RIGHT,
    REAR,
    REAR_LEFT,
    REAR_RIGHT
];

export const find = value => values().find(side => side.toString() === value);
